"use client";

import { useEffect } from "react";

export function SEOHead() {
  useEffect(() => {
    // Preload critical resources for LCP optimization
    const preloadHero = document.createElement("link");
    preloadHero.rel = "preload";
    preloadHero.as = "image";
    preloadHero.href = "/hero2.png";
    preloadHero.setAttribute("fetchpriority", "high");
    document.head.appendChild(preloadHero);

    const preloadLogo = document.createElement("link");
    preloadLogo.rel = "preload";
    preloadLogo.as = "image";
    preloadLogo.href = "/logo.png";
    document.head.appendChild(preloadLogo);

    return () => {
      // Cleanup on unmount
      document.head.removeChild(preloadHero);
      document.head.removeChild(preloadLogo);
    };
  }, []);

  return null;
}

